import { NatureEnum } from './nature';
import { EntrySource } from './worksheet';

export enum WorksheetEntryStatusEnum {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
}

export type WorksheetEntry = {
    id: string;
    worksheetId: string;
    workpaperId: string;
    reference: number;
    sequence: number;
    description?: string | null;
    amount: number;
    nature: NatureEnum;
    date: string;
    createdAt: string;
    updatedAt: string;
    attachments: string[];
    status: WorksheetEntryStatusEnum;
    source: EntrySource | null;
    priorEntryId?: string | null;
};

export type NewWorksheetEntry = {
    worksheetId: string;
    description?: string;
    date: string;
    attachments: string[];
    nature: NatureEnum;
    amount: number;
};

export type UpdateWorksheetEntryFields = {
    id: string;
    fields: Partial<WorksheetEntry>;
};

export type WorksheetEntryOverview = Pick<WorksheetEntry, 'id' | 'amount' | 'nature'>;
